import HTMLReactParser from "html-react-parser";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";



export const isoToEmoji = (code) => {

    if (!code || code.length !== 2) return '-';

    return code
        .split('')
        .map(letter => letter.charCodeAt(0) % 32 + 0x1F1E5)
        .map(emojiCode => String.fromCodePoint(emojiCode))
        .join('')
}


export const capitalize = s => s[0] ? s[0].toUpperCase() + s.slice(1) : '';

// Construit l'URL de self-register-slot pour un contact (+ presta si connue).
// id_contact/id_presta suffisent : la page cible recharge elle-même le contact et sa presta
// via ces ids (getContact / getPrestaList) — on évite de faire transiter nom, email,
// téléphone, LinkedIn… en clair dans l'URL (historique navigateur, logs serveur, partage du lien).
export const buildSelfRegisterUrl = ({ baseUrl, roleId = 143, idConfEvent, idConferencier, contact, presta }) => {
    const params = new URLSearchParams({ id_event_contact_type: roleId });
    if (idConfEvent) params.set('id_conf_event', idConfEvent);
    // id_conferencier bascule SelfRegisterSlot en mode "mise à jour" : sans lui, chaque
    // envoi/soumission du lien recrée un conf_event + conferencier au lieu de réutiliser
    // le rendez-vous déjà pris par ce contact.
    if (idConferencier) params.set('id_conferencier', idConferencier);
    if (contact) {
        params.set('id_contact', contact.id_contact);
        if (presta?.id_presta) params.set('id_presta', presta.id_presta);
    }
    return `${baseUrl}?${params.toString()}`;
};

export const removeTags = (str) => str.replace(/(<([^>]+)>)/ig, '');

export const arrayFiltered = (arg, arr) => {

    return arr.filter((item, index, self) =>
        index === self.findIndex((t) => (
            t[arg] === item[arg]
        ))
    )
}


// Utility function to capitalize the first letter of a string
export const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
};


export const sortByAttribute = (array, ...attrs) => {
    // generate an array of predicate-objects contains
    // property getter, and descending indicator
    let predicates = attrs.map(pred => {
        let descending = pred.charAt(0) === '-' ? -1 : 1;
        pred = pred.replace(/^-/, '');
        return {
            getter: o => o[pred],
            descend: descending
        };
    });
    // schwartzian transform idiom implementation. aka: "decorate-sort-undecorate"
    return array.map(item => {
        return {
            src: item,
            compareValues: predicates.map(predicate => predicate.getter(item))
        };
    })
        .sort((o1, o2) => {
            let i = -1, result = 0;
            while (++i < predicates.length) {
                if (o1.compareValues[i] < o2.compareValues[i]) result = -1;
                if (o1.compareValues[i] > o2.compareValues[i]) result = 1;
                if (result *= predicates[i].descend) break;
            }
            return result;
        })
        .map(item => item.src);
}

export const removeDuplicateObjectFromArray = (array, key) => {
    var check = new Set();
    return array.filter(obj => !check.has(obj[key]) && check.add(obj[key]));
}

export const removeDuplicateObjectsByProperty = (arr, property) => {
    return arr.filter(function (item, index) {
        return index === arr.findIndex(obj => obj[property] === item[property]);
    });
}

export const isDev = () => {

    return !process.env.NODE_ENV || process.env.NODE_ENV === 'development'

}

export const arrayIntersection = (arr1, arr2) => {
    const set = new Set(arr2);
    const intersection = new Set(arr1.filter(elem => set.has(elem)));
    return Array.from(intersection);
}
export const mobileCheck = () => {
    if (
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
    ) {
        return true;
    } else {
        return false;
    }
};



export const hidePartOfString = (str, start, end) => {
    let hiddenStr = "";
    for (let i = 0; i < str.length; i++) {
        if (i >= start && i < end) {
            hiddenStr += "*";
        } else {
            hiddenStr += str[i];
        }
    }
    return hiddenStr;
};

export const dataUrlToFile = (dataUrl, fileName) => {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
}

export const formatTimeToLocale = (timeString, locale) => {
    if (!timeString) return "N/A";

    // Créer un objet Date avec l'heure fournie (utilise la date du jour)
    const today = new Date();
    const [hours, minutes, seconds] = timeString.split(':');
    today.setHours(parseInt(hours, 10), parseInt(minutes, 10), parseInt(seconds || 0, 10));

    // Définir les locales qui utilisent le format 12h (AM/PM)
    const localesWithAMPM = ['en-US', 'en-CA', 'en-AU', 'en-NZ', 'en-PH'];
    const shouldUse12Hour = localesWithAMPM.includes(locale);

    // Formater selon la locale et le format horaire approprié
    return today.toLocaleTimeString(locale || 'fr-FR', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: shouldUse12Hour // true pour AM/PM, false pour 24h
    });
};


export const CheckData = ({ value, name, content, setShowEditSection, className, valueClassName }) => {

    const { t } = useTranslation();

    useEffect(() => {
        // console.log(name, value)
    }, [value])

    const val = ["", null, false, " ", undefined, "undefined", '[]', []].includes(value) ? <a className='text-red-600 mr-2 cursor-pointer' onClick={() => setShowEditSection && setShowEditSection(true)}  >{t("global.ajouter")} </a> : value;

    return <div className="flex flex-row justify-center items-center">
        <div className="pr-2   basis-2/6">
            <div className="text-right">
                {capitalizeFirstLetter(name)} <span>:</span>
            </div>
        </div>
        <div className="basis-4/6 p-1">
            <div className="flex items-center">
                <div className={valueClassName}>
                    {(() => {
                        // Condition pour les valeurs vides/nulles/non définies
                        if (["", null, false, " ", undefined, "undefined", '[]', []].includes(value) || (Array.isArray(value) && value.length === 0)) {
                            return <a className='text-red-600 mr-2 cursor-pointer' onClick={() => setShowEditSection && setShowEditSection(true)}  >{t("global.ajouter")} </a>;
                        }

                        if (typeof value === 'string') {
                            // Condition pour les vidéos MP4
                            if (value.includes('.mp4')) {
                                let mp4Src = value;
                                // Si ce n'est pas une URL complète, on la préfixe
                                if (!value.startsWith('http://') && !value.startsWith('https://') && !value.startsWith('//')) {
                                    mp4Src = `//www.mlg-consulting.com/manager_cc/docs/archives/${value}`;
                                }
                                return (
                                    <video
                                        className="w-64"
                                        controls
                                    >
                                        <source src={mp4Src} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                );
                            }

                            // Condition pour les vidéos YouTube
                            let youtubeVideoId = null;
                            if (value.includes('youtube.com/watch')) {
                                const params = value.split('v=')[1];
                                if (params) {
                                    youtubeVideoId = params.split('&')[0];
                                }
                            } else if (value.includes('youtu.be/')) {
                                const pathSegment = value.split('youtu.be/')[1];
                                if (pathSegment) {
                                    youtubeVideoId = pathSegment.split(/[?&]/)[0]; // Extrait l'ID avant '?' ou '&'
                                }
                            }

                            if (youtubeVideoId) {
                                return (
                                    <iframe
                                        className="w-64"
                                        src={`https://www.youtube.com/embed/${youtubeVideoId}`}
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                );
                            }
                        }

                        // Fallback: afficher la valeur telle quelle si ce n'est pas une vidéo reconnue ou une valeur vide
                        return value;
                    })()}
                    {content} {/* Affiche le contenu additionnel passé en prop */}
                </div>
            </div>
        </div>
    </div>
}